import { cx } from "@shared/components/untitledui/util/cx"
import type { Course, CourseDateAnnotationSingle } from "@shared/models/course"
import type { CourseDateCombined } from "@shared/models/course-date-combined"
import { tracked } from "@supergrain/kernel/react"
import CourseDateAnnotation from "react-app/components/planner/card-stacks/CourseDateAnnotation"

/**
 * `Planner::CardStacks::Lesson::DateAnnotations`: the day's notes, under the course title bar.
 * The bar owns the course's name — printing it here too gave the slot two of them.
 */
export default tracked(function LessonDateAnnotations({
  course,
  courseDate,
  hasSlotBelow,
}: {
  course: Course
  courseDate: CourseDateCombined
  /** Whether the lesson follows; without it the notes close the card and round its bottom. */
  hasSlotBelow: boolean
}) {
  return (
    // Ember rendered these inside the lesson's course-colored wrapper; here the wrapper starts at
    // the title bar, so the block carries the color itself.
    <div
      data-test="lesson date annotations"
      className={cx(
        "set-course-color-vars take-course-background-color",
        !hasSlotBelow && "rounded-b-md",
      )}
      data-color={course.attributes.color}
    >
      {courseDate.visibleAnnotations
        // The calc only ever puts single-date annotations here; this narrows the union.
        .filter(
          (annotation): annotation is CourseDateAnnotationSingle =>
            annotation.type === "date-annotation-course-custom-single",
        )
        .map((annotation) => (
          <CourseDateAnnotation annotation={annotation} course={course} key={annotation.id} />
        ))}
    </div>
  )
})
